// --- Action Creators for Fetching Comunas Destino ---
export const COT20_FETCH_COMUNAS_DESTINO_REQUEST = 'cot20/FETCH_COMUNAS_DESTINO_REQUEST';
export const COT20_FETCH_COMUNAS_DESTINO_SUCCESS = 'cot20/FETCH_COMUNAS_DESTINO_SUCCESS';
export const COT20_FETCH_COMUNAS_DESTINO_FAILURE = 'cot20/FETCH_COMUNAS_DESTINO_FAILURE';
// --- End Action Creators for Fetching Comunas Destino ---

export const fetchGetComunasDestinoRequest = () => ({
  type: COT20_FETCH_COMUNAS_DESTINO_REQUEST,
}); 

export const fetchGetComunasDestinoSuccess = (payload) => ({
  type: COT20_FETCH_COMUNAS_DESTINO_SUCCESS,
  payload: payload,
});

export const fetchGetComunasDestinoFailure = (error) => ({
  type: COT20_FETCH_COMUNAS_DESTINO_FAILURE,
  payload: error,
});

// --- Action Creators for Fetching Puertos ---
export const COT20_FETCH_PUERTOS_REQUEST = 'cot20/FETCH_PUERTOS_REQUEST';
export const COT20_FETCH_PUERTOS_SUCCESS = 'cot20/FETCH_PUERTOS_SUCCESS';
export const COT20_FETCH_PUERTOS_FAILURE = 'cot20/FETCH_PUERTOS_FAILURE';
// --- End Action Creators for Fetching Puertos ---

// --- Action Creators for Fetching Puertos ---
export const fetchGetPuertosRequest = () => ({
  type: COT20_FETCH_PUERTOS_REQUEST,
}); 

export const fetchGetPuertosSuccess = (payload) => ({
  type: COT20_FETCH_PUERTOS_SUCCESS,
  payload: payload,
});

export const fetchGetPuertosFailure = (error) => ({
  type: COT20_FETCH_PUERTOS_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Puertos ---

// --- Action Creators for Fetching Ejecutivos ---
export const COT20_FETCH_EJECUTIVOS_REQUEST = 'cot20/FETCH_EJECUTIVOS_REQUEST';
export const COT20_FETCH_EJECUTIVOS_SUCCESS = 'cot20/FETCH_EJECUTIVOS_SUCCESS';
export const COT20_FETCH_EJECUTIVOS_FAILURE = 'cot20/FETCH_EJECUTIVOS_FAILURE';
// --- End Action Creators for Fetching Ejecutivos ---

// --- Action Creators for Fetching Ejecutivos ---
export const fetchGetEjecutivosRequest = () => ({
  type: COT20_FETCH_EJECUTIVOS_REQUEST,
});

export const fetchGetEjecutivosSuccess = (payload) => ({
  type: COT20_FETCH_EJECUTIVOS_SUCCESS,
  payload: payload,
});

export const fetchGetEjecutivosFailure = (error) => ({
  type: COT20_FETCH_EJECUTIVOS_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Ejecutivos ---  

// --- Action Creators for Fetching Servicios ---
export const COT20_FETCH_SERVICIOS_REQUEST = 'cot20/FETCH_SERVICIOS_REQUEST';
export const COT20_FETCH_SERVICIOS_SUCCESS = 'cot20/FETCH_SERVICIOS_SUCCESS';
export const COT20_FETCH_SERVICIOS_FAILURE = 'cot20/FETCH_SERVICIOS_FAILURE';
// --- End Action Creators for Fetching Servicios ---

// --- Action Creators for Fetching Servicios ---
export const fetchGetServiciosRequest = () => ({
  type: COT20_FETCH_SERVICIOS_REQUEST,
}); 

export const fetchGetServiciosSuccess = (payload) => ({
  type: COT20_FETCH_SERVICIOS_SUCCESS,
  payload: payload,
});

export const fetchGetServiciosFailure = (error) => ({
  type: COT20_FETCH_SERVICIOS_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Servicios ---

// --- Action Creators for Fetching Set Success Dialog Global ---
export const COT20_FETCH_SET_SUCCESS_DIALOG_GLOBAL = 'cot20/FETCH_SET_SUCCESS_DIALOG_GLOBAL'; 

export const fetchSetSuccessDialogGlobal = (payload) => ({
  type: COT20_FETCH_SET_SUCCESS_DIALOG_GLOBAL,
  payload: payload,
});
// --- End Action Creators for Fetching Set Success Dialog Global --- 

// --- Action Creators for Fetching Set Error Dialog Global ---
export const COT20_FETCH_SET_ERROR_DIALOG_GLOBAL = 'cot20/FETCH_SET_ERROR_DIALOG_GLOBAL'; 

export const fetchSetErrorDialogGlobal = (payload) => ({
  type: COT20_FETCH_SET_ERROR_DIALOG_GLOBAL,
  payload: payload,
});
// --- End Action Creators for Fetching Set Error Dialog Global ---

// --- Action Creators for Global Loading ---
export const SHOW_GLOBAL_LOADING = 'SHOW_GLOBAL_LOADING';
export const HIDE_GLOBAL_LOADING = 'HIDE_GLOBAL_LOADING';

export const hideGlobalLoading = () => ({
  type: HIDE_GLOBAL_LOADING,
});

export const showGlobalLoading = () => ({
  type: SHOW_GLOBAL_LOADING,
});

// --- Action Creators for Fetching Tipos Cargas ---
export const COT20_FETCH_TIPOS_CARGAS_REQUEST = 'cot20/FETCH_TIPOS_CARGAS_REQUEST';
export const COT20_FETCH_TIPOS_CARGAS_SUCCESS = 'cot20/FETCH_TIPOS_CARGAS_SUCCESS';
export const COT20_FETCH_TIPOS_CARGAS_FAILURE = 'cot20/FETCH_TIPOS_CARGAS_FAILURE';
// --- End Action Creators for Fetching Tipos Cargas ---

// --- Action Creators for Fetching Tipos Cargas ---
export const fetchGetTiposCargasRequest = () => ({
  type: COT20_FETCH_TIPOS_CARGAS_REQUEST,
}); 

export const fetchGetTiposCargasSuccess = (payload) => ({
  type: COT20_FETCH_TIPOS_CARGAS_SUCCESS,
  payload: payload,
});

export const fetchGetTiposCargasFailure = (error) => ({
  type: COT20_FETCH_TIPOS_CARGAS_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Tipos Cargas ---

// --- Action Creators for Fetching Tipos Contenedores ---  
export const COT20_FETCH_TIPOS_CONTENEDORES_REQUEST = 'cot20/FETCH_TIPOS_CONTENEDORES_REQUEST';
export const COT20_FETCH_TIPOS_CONTENEDORES_SUCCESS = 'cot20/FETCH_TIPOS_CONTENEDORES_SUCCESS';
export const COT20_FETCH_TIPOS_CONTENEDORES_FAILURE = 'cot20/FETCH_TIPOS_CONTENEDORES_FAILURE';
// --- End Action Creators for Fetching Tipos Contenedores ---  

// --- Action Creators for Fetching Tipos Contenedores ---  
export const fetchGetTiposContenedoresRequest = () => ({
  type: COT20_FETCH_TIPOS_CONTENEDORES_REQUEST,
});

export const fetchGetTiposContenedoresSuccess = (payload) => ({
  type: COT20_FETCH_TIPOS_CONTENEDORES_SUCCESS,
  payload: payload,
});

export const fetchGetTiposContenedoresFailure = (error) => ({
  type: COT20_FETCH_TIPOS_CONTENEDORES_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Tipos Contenedores ---  

// --- Action Creators for Fetching Tipos Incoterms --- 
export const COT20_FETCH_TIPOS_INCOTERMS_REQUEST = 'cot20/FETCH_TIPOS_INCOTERMS_REQUEST';
export const COT20_FETCH_TIPOS_INCOTERMS_SUCCESS = 'cot20/FETCH_TIPOS_INCOTERMS_SUCCESS';
export const COT20_FETCH_TIPOS_INCOTERMS_FAILURE = 'cot20/FETCH_TIPOS_INCOTERMS_FAILURE';
// --- End Action Creators for Fetching Tipos Incoterms ---  

// --- Action Creators for Fetching Tipos Incoterms ---  
export const fetchGetTiposIncotermsRequest = () => ({
  type: COT20_FETCH_TIPOS_INCOTERMS_REQUEST,
}); 

export const fetchGetTiposIncotermsSuccess = (payload) => ({
  type: COT20_FETCH_TIPOS_INCOTERMS_SUCCESS,
  payload: payload,
}); 

export const fetchGetTiposIncotermsFailure = (error) => ({
  type: COT20_FETCH_TIPOS_INCOTERMS_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Tipos Incoterms ---  

// --- Action Creators for Fetching Link Whatsapp ---
export const COT20_FETCH_NUMERO_WHATSAPP_REQUEST = 'cot20/FETCH_NUMERO_WHATSAPP_REQUEST';
export const COT20_FETCH_NUMERO_WHATSAPP_SUCCESS = 'cot20/FETCH_NUMERO_WHATSAPP_SUCCESS';
export const COT20_FETCH_NUMERO_WHATSAPP_FAILURE = 'cot20/FETCH_NUMERO_WHATSAPP_FAILURE';
export const COT20_FETCH_SET_NUMERO_WHATSAPP = 'cot20/FETCH_SET_NUMERO_WHATSAPP';
// --- End Action Creators for Fetching Link Whatsapp --- 

// --- Action Creators for Fetching Link Whatsapp ---
export const fetchSetNumeroWhatsapp = (payload) => ({
  type: COT20_FETCH_SET_NUMERO_WHATSAPP,
  payload: payload,
});

export const fetchGetNumeroWhatsappRequest = () => ({
  type: COT20_FETCH_NUMERO_WHATSAPP_REQUEST,
}); 

export const fetchGetNumeroWhatsappSuccess = (payload) => ({
  type: COT20_FETCH_NUMERO_WHATSAPP_SUCCESS,
  payload: payload,
}); 

export const fetchGetNumeroWhatsappFailure = (error) => ({
  type: COT20_FETCH_NUMERO_WHATSAPP_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Link Whatsapp ---

// --- Action Creators for Fetching Set Cotizacion ---
export const COT20_FETCH_SET_COTIZACION = 'cot20/FETCH_SET_COTIZACION';
export const COT20_FETCH_SET_COTIZACION_SUCCESS = 'cot20/FETCH_SET_COTIZACION_SUCCESS';
export const COT20_FETCH_SET_COTIZACION_FAILURE = 'cot20/FETCH_SET_COTIZACION_FAILURE';
// --- End Action Creators for Fetching Set Cotizacion ---

// --- Action Creators for Fetching Set Cotizacion ---
export const fetchSetCotizacion = (payload) => ({
  type: COT20_FETCH_SET_COTIZACION,
  payload: payload,
}); 

export const fetchSetCotizacionSuccess = (payload) => ({
  type: COT20_FETCH_SET_COTIZACION_SUCCESS,
  payload: payload,
});

export const fetchSetCotizacionFailure = (error) => ({
  type: COT20_FETCH_SET_COTIZACION_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Set Cotizacion ---

// --- Action Creators for Fetching Set Cotizacion Errors ---   
export const COT20_FETCH_SET_COTIZACION_ERRORS = 'cot20/FETCH_SET_COTIZACION_ERRORS'; 
export const COT20_FETCH_SET_COTIZACION_ERRORS_SUCCESS = 'cot20/FETCH_SET_COTIZACION_ERRORS_SUCCESS';
export const COT20_FETCH_SET_COTIZACION_ERRORS_FAILURE = 'cot20/FETCH_SET_COTIZACION_ERRORS_FAILURE';
// --- End Action Creators for Fetching Set Cotizacion Errors ---   

// --- Action Creators for Fetching Set Cotizacion Errors ---   
export const fetchSetCotizacionErrors = (payload) => ({
  type: COT20_FETCH_SET_COTIZACION_ERRORS,
  payload: payload,
}); 

export const fetchSetCotizacionErrorsSuccess = (payload) => ({
  type: COT20_FETCH_SET_COTIZACION_ERRORS_SUCCESS,
  payload: payload,
}); 

export const fetchSetCotizacionErrorsFailure = (error) => ({
  type: COT20_FETCH_SET_COTIZACION_ERRORS_FAILURE,
  payload: error,
}); 
// --- End Action Creators for Fetching Set Cotizacion Errors ---   

// --- Action Creators for Fetching Cliente By Id ---
export const COT20_FETCH_GET_CLIENTE_BY_ID = 'cot20/FETCH_GET_CLIENTE_BY_ID';
export const COT20_FETCH_GET_CLIENTE_BY_ID_SUCCESS = 'cot20/FETCH_GET_CLIENTE_BY_ID_SUCCESS';
export const COT20_FETCH_GET_CLIENTE_BY_ID_FAILURE = 'cot20/FETCH_GET_CLIENTE_BY_ID_FAILURE';
// --- End Action Creators for Fetching Cliente By Id --- 

// --- Action Creators for Fetching Cliente By Id ---
export const fetchGetClienteById = (payload) => ({
  type: COT20_FETCH_GET_CLIENTE_BY_ID,
  payload: payload,
}); 

export const fetchGetClienteByIdSuccess = (payload) => ({
  type: COT20_FETCH_GET_CLIENTE_BY_ID_SUCCESS,
  payload: payload,
}); 

export const fetchGetClienteByIdFailure = (error) => ({
  type: COT20_FETCH_GET_CLIENTE_BY_ID_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Cliente By Id --- 

// --- Action Creators for Fetching Cotizacion 20 Save ---
export const COT20_FETCH_COTIZACION_20_SAVE = 'cot20/FETCH_COTIZACION_20_SAVE';
export const COT20_FETCH_COTIZACION_20_SAVE_SUCCESS = 'cot20/FETCH_COTIZACION_20_SAVE_SUCCESS';
export const COT20_FETCH_COTIZACION_20_SAVE_FAILURE = 'cot20/FETCH_COTIZACION_20_SAVE_FAILURE';
// --- End Action Creators for Fetching Cotizacion 20 Save ---  

// --- Action Creators for Fetching Cotizacion 20 Save ---
export const fetchCotizacion20Save = (payload) => ({
  type: COT20_FETCH_COTIZACION_20_SAVE,
  payload: payload,
}); 

export const fetchCotizacion20SaveSuccess = (payload) => ({
  type: COT20_FETCH_COTIZACION_20_SAVE_SUCCESS,
  payload: payload,
});  

export const fetchCotizacion20SaveFailure = (error) => ({
  type: COT20_FETCH_COTIZACION_20_SAVE_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Cotizacion 20 Save ---  

// --- Action Creators for Fetching Cotizacion 20 Accept ---
export const COT20_FETCH_COTIZACION_20_ACCEPT = 'cot20/FETCH_COTIZACION_20_ACCEPT';
export const COT20_FETCH_COTIZACION_20_ACCEPT_SUCCESS = 'cot20/FETCH_COTIZACION_20_ACCEPT_SUCCESS';
export const COT20_FETCH_COTIZACION_20_ACCEPT_FAILURE = 'cot20/FETCH_COTIZACION_20_ACCEPT_FAILURE';
// --- End Action Creators for Fetching Cotizacion 20 Accept ---  

// --- Action Creators for Fetching Cotizacion 20 Accept ---
export const fetchCotizacion20Accept = (payload) => ({
  type: COT20_FETCH_COTIZACION_20_ACCEPT,
  payload: payload,
}); 

export const fetchCotizacion20AcceptSuccess = (payload) => ({
  type: COT20_FETCH_COTIZACION_20_ACCEPT_SUCCESS,
  payload: payload,
});

export const fetchCotizacion20AcceptFailure = (error) => ({
  type: COT20_FETCH_COTIZACION_20_ACCEPT_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Cotizacion 20 Accept ---   

// --- Action Creators for Fetching Servicios Valores ---
export const COT20_FETCH_SERVICIOS_VALORES_REQUEST = 'cot20/FETCH_SERVICIOS_VALORES_REQUEST';
export const COT20_FETCH_SERVICIOS_VALORES_SUCCESS = 'cot20/FETCH_SERVICIOS_VALORES_SUCCESS';
export const COT20_FETCH_SERVICIOS_VALORES_FAILURE = 'cot20/FETCH_SERVICIOS_VALORES_FAILURE';
// --- End Action Creators for Fetching Servicios Valores ---

// --- Action Creators for Fetching Servicios Valores ---
export const fetchGetServiciosValoresRequest = () => ({
  type: COT20_FETCH_SERVICIOS_VALORES_REQUEST,
});

export const fetchGetServiciosValoresSuccess = (payload) => ({
  type: COT20_FETCH_SERVICIOS_VALORES_SUCCESS,
  payload: payload,
});

export const fetchGetServiciosValoresFailure = (error) => ({
  type: COT20_FETCH_SERVICIOS_VALORES_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Servicios Valores ---

// --- Action Creators for Fetching Send Email Cotizacion ---
export const COT20_FETCH_SEND_EMAIL_COTIZACION = 'cot20/FETCH_SEND_EMAIL_COTIZACION';
export const COT20_FETCH_SEND_EMAIL_COTIZACION_SUCCESS = 'cot20/FETCH_SEND_EMAIL_COTIZACION_SUCCESS';
export const COT20_FETCH_SEND_EMAIL_COTIZACION_FAILURE = 'cot20/FETCH_SEND_EMAIL_COTIZACION_FAILURE';
// --- End Action Creators for Fetching Send Email Cotizacion --- 

// --- Action Creators for Fetching Send Email Cotizacion ---
export const fetchSendEmailCotizacion = (payload) => ({
  type: COT20_FETCH_SEND_EMAIL_COTIZACION,
  payload: payload,
}); 

export const fetchSendEmailCotizacionSuccess = (payload) => ({
  type: COT20_FETCH_SEND_EMAIL_COTIZACION_SUCCESS,
  payload: payload,
});   

export const fetchSendEmailCotizacionFailure = (error) => ({
  type: COT20_FETCH_SEND_EMAIL_COTIZACION_FAILURE,
  payload: error,
});
// --- End Action Creators for Fetching Send Email Cotizacion ---




















































































